export enum LinkType {
  Global = 'Global',
  Individual = 'Individual'
}
